<div
  class="modal-header"
  hsDraggable="modal-dialog"
  hsResizable="modal-content"
>
  <h4 class="modal-title">{{ title }}</h4>
  <button
    nf-icon-button
    icon="close"
    class="btn-bare"
    (click)="activeModal.dismiss()"
  >
    Close
  </button>
</div>
<div class="modal-body" hsDraggable="modal-dialog">
  <ng-container>
    <nf-table-layout
      class="fx-entry-table"
      hideTitle
      [isSectionTitle]="false"
      [gridOptions]="gridOptions"
      [data]="rowData"
      hideSearch
      [autoResizeGrid]="false"
      hideClearAll
    >
    </nf-table-layout>
    <nf-form-control
      class="notes-control"
      label="Notes"
      [customErrorMessages]="getFieldValidatorFormatter('transactionNote')"
      [warnings]="noteWarning"
    >
      <textarea
        rows="3"
        class="form-control"
        id="notesText"
        [formControl]="note"
        (focus)="disableGridFocus()"
      ></textarea>
    </nf-form-control>

    <nf-form-control
      class="forbidden-control"
      label="Missing Permissions : "
      [customErrorMessages]="getFieldValidatorFormatter('forbiddenErrors')"
      [hidden]="!forbiddenErrors.errors"
    >
      <p id="forbiddenText" class="form-control">{{ forbiddenErrors.value }}</p>
    </nf-form-control>
  </ng-container>
  <hs-loader
    class="{{ !transactionLoaded || formSubmitting ? 'active' : '' }}"
    [loading]="!transactionLoaded || formSubmitting"
    [label]="loadingText"
    [errorLabel]="errorText"
    [showText]="!transactionLoaded || formSubmitting"
  ></hs-loader
  ><hs-dialog-error-details
    [errorHeader]="errorHeader"
    [errorDetails]="errorDetails"
  ></hs-dialog-error-details>
</div>
<div class="modal-footer justify-content-between" hsDraggable="modal-dialog">
  <div class="left-controls">
    <nf-checkbox
      [formControl]="clearTransaction"
      label="Clear Transaction"
    ></nf-checkbox>
  </div>
  <div class="right-controls">
    <span *ngIf="isValidating" class="mdi mdi-loading">validating..</span>
    <button nf-button="cancel" (click)="activeModal.dismiss()"></button>
    <button
      *ngIf="!transInput?.readOnly"
      nf-button="submit"
      [loading]="formSubmitting"
      [disabled]="!isDataValid || this.isCellEditing"
      (click)="save()"
    >
      Save
    </button>
  </div>
</div>
